import { ArrowDown } from "lucide-react";
import type { FC } from "react";

import type { ProtocolData } from "../../../protocols";
import { protocolIconUrl } from "../../../protocols";

export interface ProtocolProps {
  protocol: ProtocolData;
  isUnderlying?: boolean;
}

export const Protocol: FC<ProtocolProps> = ({ protocol, isUnderlying }) => {
  return (
    <div className="inline-flex items-center min-w-0">
      {isUnderlying && (
        <div className="mr-2 inline-block text-gray-400">
          <ArrowDown size={12} />
        </div>
      )}
      <div className="mr-1.5 inline-flex w-7 h-7 justify-center items-center bg-black rounded-full overflow-hidden flex-shrink-0">
        {protocol.icon ? (
          <img
            src={protocolIconUrl(protocol.icon)}
            alt={protocol.name}
            className="max-w-[18px] h-[18px]"
          />
        ) : (
          <span className="text-[9px] text-gray-300">?</span>
        )}
      </div>
      <span className="truncate">{protocol.name}</span>
    </div>
  );
};
